import { useQuery, QueryClientProvider } from '@tanstack/react-query';
import React, { useState, useEffect  } from 'react';
import styled from 'styled-components';
import { searchClient } from '../components/providers/instantSearchClient';
import { queryClient } from '../components/providers/queryClient';
import { fetchFromAPI } from '../utils';
import PageSearchSearchWidget from "../full-page-search/make-full-page-search";
import ComboBox from '../components/atoms/comboBox';



export default function MakeMachineModel() {
  const [selectedModel, setSelectedModel] = useState('');
  const [selectedMachine, setSelectedMachine] = useState('');
  const [selectedMake, setSelectedMake] = useState('');
  const [facetFilters, setFacetFilters] = useState([]);
  const [skusFromMMM, setSkusFromMMM] = useState([]);
  const [initializedFromURL,setInitializedFromURL]=useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setSelectedModel(searchParams.get('model')||'')
    setSelectedMachine(searchParams.get('machine')||'')
    setSelectedMake(searchParams.get('make')|| '')
    setInitializedFromURL(true)
  },[]);
  
  useEffect(() => {
    const filters = [];
    if (selectedMake) {
      filters.push(`Make:"${selectedMake}"`);
    }
    if (selectedModel) {
      filters.push(`Model:"${selectedModel}"`);
    }
    if (selectedMachine) {
      filters.push(`Machine:"${selectedMachine}"`);
    }
    setFacetFilters(filters);
  }, [selectedMake, selectedMachine, selectedModel]);
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    const fetchSkusfromMMM = async () => {
      if(facetFilters.length > 0){
      try{
      const response = await fetchFromAPI(`/machine-make-model/skus?make=${selectedMake}&machine=${selectedMachine}&model=${selectedModel}`);
      const data = response.data;
      if(Array.isArray(data)){
        setSkusFromMMM(data);
    }else{
      setSkusFromMMM([]);
    }
    } catch (error) {
      console.log(error);
      setSkusFromMMM([]);
    }
  }else{
    setSkusFromMMM([]);
  }
};
    fetchSkusfromMMM();
  }, [facetFilters]);
  return (
    <StyledMachineContainer>
      <StyledWrapper>
        <h2 className="styled-text">Search by Make/Machine/Model</h2>
        <StyledContainer className="form-fields" onSubmit={handleSubmit}>
          <QueryClientProvider client={queryClient}>
          {initializedFromURL && (
            <>
            <MakeContainer onChange={(newMake)=>{
              setSelectedMake(newMake)
              setSelectedMachine("")
              setSelectedModel("")
            }}
            selectedMake={selectedMake} 
            />
            <MachineContainer
              onChange={(newMachine)=>{
              setSelectedMachine(newMachine)
              setSelectedModel("")
            }}
              selectedMake={selectedMake}
              selectedMachine={selectedMachine}
            />
            <ModelContainer
              onChange={setSelectedModel}
              selectedMake={selectedMake}
              selectedMachine={selectedMachine}
              selectedModel={selectedModel}
            />
            </>
          )}
          </QueryClientProvider>
        </StyledContainer>
        {facetFilters.length > 2 ? (
            <AlgoliaSearchResultsContainer>
                <PageSearchSearchWidget Skus={skusFromMMM} facetFilters={facetFilters} />
            </AlgoliaSearchResultsContainer>
        ) : null}
      </StyledWrapper>
    </StyledMachineContainer>
  );
}


const StyledContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: var(--color--light-grey);
  padding: 20px;
  margin-bottom: 20px;

  @media(min-width: 1025px) {
    flex-direction: row;
     gap: 70px;
  }
  
`;

const StyledWrapper = styled.div`
  .styled-text {
    color: var(--color--black);
    margin-top: 20px;
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 16px;
  }
    .styled-text1{
    color: var(--color--dark-green);
    margin-top: 20px;
    font-size: 26px;
    line-height: 36px;
    margin-bottom: 16px;
    }
`;

const StyledMachineContainer = styled.div`
  .u-color--dark-green {
    line-height: 2em;
  }

  @media (min-width: 1025px) {
      flex-flow: row;
}

flex-flow: column;
`;

const AlgoliaSearchResultsContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

function MakeContainer({ onChange,selectedMake}) {
  const { data} = useQuery({
    queryKey: ['makes'],
    queryFn: () => fetchFromAPI(`/machine-make-model/makes`),
    select: (data) => data?.data || [],
  });
  return(
  <ComboBox placeholder="Select Make"  onChange={onChange} items={data} value={selectedMake}/>
)
}



function MachineContainer({onChange, selectedMake,selectedMachine}) {
  const { data} = useQuery({
    queryKey: ['machines', selectedMake],
    queryFn: async () => {
      if(!selectedMake) { return []; }
      return await fetchFromAPI(`/machine-make-model/machines?make=${selectedMake}`)
    },
  select: (data) =>{ return data?.data;},
  enabled: !!selectedMake,
  });
  return ( 
    <ComboBox placeholder="Select Machine" items={data} onChange={onChange} value={selectedMachine} disabled={!selectedMake} />
);

}

function ModelContainer({onChange,selectedMake, selectedMachine,selectedModel}) {
  const { data} = useQuery({
    queryKey: ['models', selectedMake, selectedMachine],
    queryFn: async () => {
      if(!selectedMake || !selectedMachine) { return []; }
      return await fetchFromAPI(`/machine-make-model/models?make=${selectedMake}&machine=${selectedMachine}`);
    },

  select: (data) =>{ return data?.data;},
  enabled: !!selectedMake && !!selectedMachine, 
});
  return(
    <ComboBox placeholder="Select Model" items={data} onChange={onChange} value={selectedModel} disabled={!selectedMachine}/>
  )
}


